/**
 * LoadingScreen Component
 *
 * Displays a centered loading indicator during app initialization.
 * Shown while runtime configuration is being fetched (~100ms).
 *
 * Used by _app.tsx during lazy initialization of Amplify and PostHog.
 */

import React from "react";

export const LoadingScreen: React.FC = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: "50px",
          height: "50px",
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #3498db",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <p
        style={{
          marginTop: "20px",
          fontSize: "16px",
          color: "#666",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        Loading...
      </p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
